import { useState } from "react";
import { Icons, PRODUCT_TYPES, PRODUCT_ICON_MAP, PRODUCT_COLOR_MAP, PRODUCT_SHORT_LABELS } from "./bookingConstants";
import ProductCard from "./ProductCard";
import ProductFormScreen from "./ProductFormScreen";
import styles from "./AddBooking.module.css";

const StepProducts = ({ data, onChange, onRemoveProduct }) => {
  const [activeFormType, setActiveFormType] = useState(null);
  const [editingProduct, setEditingProduct] = useState(null);

  const handleSaveProduct = (product) => {
    if (editingProduct) {
      onChange("products", data.products.map((p) => p.id === product.id ? product : p));
    } else {
      onChange("products", [...data.products, product]);
    }
    setEditingProduct(null);
  };

  const handleEdit = (product) => {
    setEditingProduct(product);
    setActiveFormType(product.type);
  };

  const removeProduct = (id) => {
    const product = data.products.find((p) => p.id === id);
    if (onRemoveProduct && product) {
      onRemoveProduct(product);
      return;
    }
    onChange("products", data.products.filter((p) => p.id !== id));
    onChange("assignments", (data.assignments || []).filter((a) => a.productId !== id));
  };

  const handleCloseForm = () => {
    setActiveFormType(null);
    setEditingProduct(null);
  };

  if (activeFormType) {
    return (
      <div className={styles.stepContent}>
        <ProductFormScreen
          type={activeFormType}
          onClose={handleCloseForm}
          onSave={handleSaveProduct}
          initialData={editingProduct}
          allProducts={data.products}
        />
      </div>
    );
  }

  return (
    <div className={styles.stepContent}>
      <div className={styles.sectionBlock}>
        <div className={styles.sectionLabel}>Add Product</div>
        <div className={styles.productTypeBar}>
          {PRODUCT_TYPES.map((pt) => {
            const c = PRODUCT_COLOR_MAP[pt.key];
            return (
              <button
                key={pt.key}
                className={styles.productTypeBtn}
                onClick={() => { setEditingProduct(null); setActiveFormType(pt.key); }}
              >
                <span className={styles.productTypeBtnIcon} style={{ background: c.bg, color: c.color }}>
                  {PRODUCT_ICON_MAP[pt.key]}
                </span>
                <span className={styles.productTypeBtnLabel}>{PRODUCT_SHORT_LABELS[pt.key]}</span>
              </button>
            );
          })}
        </div>
      </div>
      {data.products.length > 0 && (
        <div className={styles.sectionBlock}>
          <div className={styles.sectionLabel}>Added Products ({data.products.length})</div>
          <div className={styles.productList}>
            {data.products.map((p) => (
              <ProductCard key={p.id} product={p} onRemove={removeProduct} onEdit={handleEdit} />
            ))}
          </div>
        </div>
      )}
      {data.products.length === 0 && (
        <div className={styles.emptyState}>
          <div className={styles.emptyIconWrap}>{Icons.box}</div>
          <div className={styles.emptyTitle}>No products added yet</div>
          <div className={styles.emptyDesc}>Select a product type above to start adding flights, hotels, transfers, cruises, and more.</div>
        </div>
      )}
      <div className={styles.infoBox}>
        <strong>Product-First Model:</strong> After adding products, you will define travelers and assign them to each product in the next steps.
      </div>
    </div>
  );
};

export default StepProducts;